import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { api, type ApiError } from '@/lib/api';
import { qk } from '@/lib/query-keys';
import type { ExpertProjectSummary } from '@/types/api';

/**
 * The projects assigned to this expert.
 *
 * Assignment-scoped, and unlike the client's list it carries the repo inventory
 * — a reviewer needs repo names to read a multi-repo diff — and
 * `protection_enforced` per repo, because that flag gates promotion to
 * production all on its own.
 */
export function useExpertProjects(): UseQueryResult<ExpertProjectSummary[], ApiError> {
  return useQuery({
    queryKey: qk.projects,
    queryFn: () => api.get<ExpertProjectSummary[]>('/expert/projects'),
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
  });
}
